import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { silentRequestContext } from 'src/app/auth/silent-request';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';
import { AbdmHiuConsent, AbdmHiuRecord, CreateAbdmHiuConsent } from './abdm-health-records.type';

@Injectable({ providedIn: 'root' })
export class AbdmHealthRecordsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.baseURl}/abha/hiu`;

  createConsent(request: CreateAbdmHiuConsent): Observable<BaseRespone<AbdmHiuConsent>> {
    return this.http.post<BaseRespone<AbdmHiuConsent>>(`${this.baseUrl}/consent-requests`, request);
  }

  retryConsent(id: number): Observable<BaseRespone<AbdmHiuConsent>> {
    return this.http.post<BaseRespone<AbdmHiuConsent>>(`${this.baseUrl}/consent-requests/${id}/retry`, {});
  }

  fetchConsent(id: number): Observable<BaseRespone<AbdmHiuConsent>> {
    return this.http.post<BaseRespone<AbdmHiuConsent>>(`${this.baseUrl}/consent-requests/${id}/fetch`, {});
  }

  checkConsentStatus(id: number): Observable<BaseRespone<AbdmHiuConsent>> {
    return this.http.post<BaseRespone<AbdmHiuConsent>>(`${this.baseUrl}/consent-requests/${id}/status`, {});
  }

  getConsents(patientId: number, silent = false): Observable<BaseRespone<AbdmHiuConsent[]>> {
    return this.http.get<BaseRespone<AbdmHiuConsent[]>>(
      `${this.baseUrl}/patients/${patientId}/consent-requests`, this.requestOptions(silent));
  }

  getRecords(patientId: number, silent = false): Observable<BaseRespone<AbdmHiuRecord[]>> {
    return this.http.get<BaseRespone<AbdmHiuRecord[]>>(
      `${this.baseUrl}/patients/${patientId}/records`, this.requestOptions(silent));
  }

  // The tab polls in the background; those calls must not toast on a transient failure.
  private requestOptions(silent: boolean): { context?: HttpContext } {
    return silent ? { context: silentRequestContext() } : {};
  }

  getRecord(id: number): Observable<BaseRespone<AbdmHiuRecord>> {
    return this.http.get<BaseRespone<AbdmHiuRecord>>(`${this.baseUrl}/records/${id}`);
  }
}
